import { useEffect, useState } from 'react';

import { readFastTracks } from '@api/fast_tracks';
import { HelpIcon, IconButtonV2 } from '@utilities';

import { HELP_CENTER_BASE_URL } from '../../pages/FastTracks/utilities/constants';
import Column from '../../layouts/Column';
import Footer from '../../../../components/Footer';
import InteractiveTile from './components/InteractiveTile';
import ModalBuildFastTrack from './components/ModalBuildFastTrack';

import styles from './_index.module.scss';

const FastTracks = () => {
  const [fastTrackRoutes, setFastTrackRoutes] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRoute, setSelectedRoute] = useState({});

  useEffect(() => {
    const fetchFastTrackRoutes = async () => {
      try {
        const response = await readFastTracks();

        setFastTrackRoutes(response);
      } catch (error) {
        console.error(error);
      }
    };

    fetchFastTrackRoutes();
  }, []);

  const handleTileClick = (route) => {
    setSelectedRoute(route);
    setIsModalOpen(true);
  };

  return (
    <div className={styles['fast-tracks-shell']}>
      <Column className={styles['fast-tracks']}>
        <div className={styles['fast-tracks-content']}>
          <div className={styles['fast-track-header']}>
            <h1>Welcome to Numerator Narratives</h1>
            <h2>Discover how to quickly create a data story to support your business objective.</h2>
          </div>
          <div className={styles['interactive-tiles']}>
            {fastTrackRoutes.map((route) => (
              <InteractiveTile key={route.id} onClick={handleTileClick} route={route} />
            ))}
          </div>
          {isModalOpen && (
            <ModalBuildFastTrack route={selectedRoute} setIsModalOpen={setIsModalOpen} />
          )}
        </div>
        <Footer />
      </Column>

      <IconButtonV2
        aria-label="Help"
        className={styles['help-button']}
        icon={<HelpIcon />}
        onClick={() => window.open(HELP_CENTER_BASE_URL, '_blank', 'noopener,noreferrer')}
        size="small"
        tooltip="Help"
        tooltipProps={{ placement: 'left' }}
        variant="subtle"
      />
    </div>
  );
};

export default FastTracks;
